<script lang="ts" setup>
import { NSkeleton } from "naive-ui";
</script>

<template>
    <div class="flex-1 overflow-auto mx-10 mb-4">
        <div class="rounded-lg border border-gray-300 bg-white">
            <!-- Table Header -->
            <div class="bg-gray-50 border-b border-gray-200">
                <div class="grid grid-cols-8 gap-4 py-3 px-3">
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        DUE DATE
                    </div>
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        TX. DATE
                    </div>
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        DESCRIPTION
                    </div>
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        AMOUNT
                    </div>
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        BANK ACCOUNT
                    </div>
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        SOURCE
                    </div>
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        STATUS
                    </div>
                    <div class="text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        COMMENTS
                    </div>
                </div>
            </div>

            <!-- Group Header Skeleton -->
            <div class="bg-gray-100 border-b border-gray-200 py-3 px-4">
                <div class="flex items-center justify-between">
                    <n-skeleton text :repeat="1" width="16rem" />
                    <div class="flex items-center gap-2">
                        <n-skeleton text :repeat="1" width="4rem" />
                        <n-skeleton height="1rem" width="1rem" />
                    </div>
                </div>
            </div>

            <!-- Table Rows Skeleton -->
            <div v-for="n in 5" :key="n" class="border-b border-gray-100 last:border-b-0">
                <div class="grid grid-cols-8 gap-4 py-4 px-3">
                    <!-- Due Date -->
                    <div class="flex flex-col gap-1">
                        <n-skeleton text :repeat="1" width="4rem" />
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Transaction Date -->
                    <div class="flex items-center">
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Description -->
                    <div class="flex flex-col gap-1">
                        <n-skeleton text :repeat="1" width="100%" />
                        <n-skeleton text :repeat="1" width="75%" />
                    </div>

                    <!-- Amount -->
                    <div class="flex items-center">
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Bank Account -->
                    <div class="flex flex-col gap-1">
                        <n-skeleton text :repeat="1" width="6rem" />
                        <n-skeleton text :repeat="1" width="4rem" />
                    </div>

                    <!-- Source -->
                    <div class="flex items-center">
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Status -->
                    <div class="flex items-center">
                        <n-skeleton height="1.5rem" width="4rem" />
                    </div>

                    <!-- Comments -->
                    <div class="flex items-center gap-2">
                        <n-skeleton circle height="1.5rem" width="1.5rem" />
                        <div class="flex flex-col gap-1 flex-1">
                            <n-skeleton text :repeat="1" width="100%" />
                            <n-skeleton text :repeat="1" width="66%" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Second Group Header Skeleton -->
            <div class="bg-gray-100 border-b border-gray-200 py-3 px-4">
                <div class="flex items-center justify-between">
                    <n-skeleton text :repeat="1" width="14rem" />
                    <div class="flex items-center gap-2">
                        <n-skeleton text :repeat="1" width="3rem" />
                        <n-skeleton height="1rem" width="1rem" />
                    </div>
                </div>
            </div>

            <!-- More Table Rows Skeleton -->
            <div v-for="n in 3" :key="n + 5" class="border-b border-gray-100 last:border-b-0">
                <div class="grid grid-cols-8 gap-4 py-4 px-3">
                    <!-- Due Date -->
                    <div class="flex flex-col gap-1">
                        <n-skeleton text :repeat="1" width="4rem" />
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Transaction Date -->
                    <div class="flex items-center">
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Description -->
                    <div class="flex flex-col gap-1">
                        <n-skeleton text :repeat="1" width="100%" />
                        <n-skeleton text :repeat="1" width="66%" />
                    </div>

                    <!-- Amount -->
                    <div class="flex items-center">
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Bank Account -->
                    <div class="flex flex-col gap-1">
                        <n-skeleton text :repeat="1" width="6rem" />
                        <n-skeleton text :repeat="1" width="4rem" />
                    </div>

                    <!-- Source -->
                    <div class="flex items-center">
                        <n-skeleton text :repeat="1" width="5rem" />
                    </div>

                    <!-- Status -->
                    <div class="flex items-center">
                        <n-skeleton height="1.5rem" width="4rem" />
                    </div>

                    <!-- Comments -->
                    <div class="flex items-center gap-2">
                        <n-skeleton circle height="1.5rem" width="1.5rem" />
                        <div class="flex flex-col gap-1 flex-1">
                            <n-skeleton text :repeat="1" width="100%" />
                            <n-skeleton text :repeat="1" width="75%" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
